import { IGameSnacks } from "../lib/GameSnacks";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class SavedData
{
    // #region Attributes //

    // private:
    private _data: IData = null;
    
    // Constants.
	private readonly _kSaveName: string = "gs-crazy-8s";
    private readonly _kVersion: number = 54;
    
    // #endregion //


    // #region Properties //
    
    public get data(): IData { return this._data; }

    // #endregion //


    // #region Methods //

    // public:
	
    public load(): void
    {
        if ( window.GameSnacks )
        {
            const kDataStr: string = window.GameSnacks.storage.getItem( this._kSaveName ) as string;
            if ( kDataStr )
            {
                this._data = JSON.parse( kDataStr );
                if ( this._data.version == undefined || this._data.version != this._kVersion )
                {
                    // Outdated.
                    this.createDefaultData();
                }
            }
            else
            {
                this.createDefaultData();
            }
        }
        else
        {
            const kDataStr: string = window.localStorage.getItem( this._kSaveName );
            if ( kDataStr )
            {
                this._data = JSON.parse( kDataStr );
                if ( this._data.version == undefined || this._data.version != this._kVersion )
                {
                    // Outdated.
                    this.createDefaultData();
                }
            }
            else
            {
                this.createDefaultData();
            }
        }
    }

        private createDefaultData(): void
        {
            this._data = { 
                version: this._kVersion,
                score: 0,
                bestScore: 0,
                isMuteSfx: false,
                isMuteMusic: false,
                isFirstGame: true,
                musicTrackIndex: 6,
                userId: null };

            this.save();
        }

    public save(): void
    {
        if ( window.GameSnacks )
        {
            window.GameSnacks.storage.setItem( this._kSaveName, JSON.stringify( this._data ) );
        }
        else
        {
            window.localStorage.setItem( this._kSaveName, JSON.stringify( this._data ) );
        }
    }
}

interface IData
{
    version: number;
    score: number;
    bestScore: number;
    isMuteSfx: boolean;
    isMuteMusic: boolean;
    isFirstGame: boolean;
    musicTrackIndex: number;
    userId: string;
}